import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
 Component,
 Inject,
 Input,
 Output,
 EventEmitter,
 OnInit,
 PLATFORM_ID,
} from '@angular/core';
import { Router } from '@angular/router';
import { LatestActiveReserveResponse } from '@core/models/DTOs/userProfile.dto';
import { WebengageService } from '@core/services/webengage.service';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';

@Component({
 selector: 'iho-last-reserve-card',
 standalone: true,
 imports: [CommonModule, RialToTomanPipe],
 providers: [],
 templateUrl: './last-reserve-card.component.html',
 styleUrls: ['./last-reserve-card.component.scss'],
})
export class LastReserveCardComponent implements OnInit {
 @Input() latestActiveReserve: LatestActiveReserveResponse = <LatestActiveReserveResponse>{};
 @Output() emitClose: EventEmitter<boolean> = new EventEmitter();
 setHour: any;
 setMinute: any;
 displayTimer: string = '';
 @Input() isMobile = false;
 constructor(
  @Inject(PLATFORM_ID) private platformId: Object,
  private webengageService: WebengageService,
  private router: Router
 ) {}
 ngOnInit(): void {
  if (isPlatformBrowser(this.platformId)) {
   setTimeout(() => {
    this.timer(this.latestActiveReserve.expire);
   }, 100);
  }
 }

 closeCard() {
  const pageRoute = this.router.routerState.snapshot.url.split('/').length;

  this.webengageService.trackIntrack('show-last-reserve-modal', {
   pageName: pageRoute == 2 ? 'PHP' : pageRoute == 3 ? 'PLP' : 'PDP',
   status:
    this.latestActiveReserve?.reserveStatusId === 112 ? 'waiting for hotel response' : 'payment',
   Platform: /Android|iPhone/.test(window.navigator.userAgent) ? 'mobile' : 'desktop',
   reserveId: this.latestActiveReserve?.reserveId,
  });
  this.emitClose.emit(true);
 }
 timer(seconds: number = 60) {
  let textSec: any = '0';
  let statSec: number = seconds;

  const timer = setInterval(() => {
   seconds--;
   if (statSec != 0) {
    statSec--;
   } else {
    statSec = 59;
   }

   if (statSec < 10) {
    textSec = '0' + statSec;
   } else {
    textSec = statSec;
   }

   const displayMinutes = Math.floor(seconds / 60);
   const displaySeconds = seconds % 60;

   const prefixMin = displayMinutes < 10 ? '0' : '';
   const prefixSec = displaySeconds < 10 ? '0' : '';

   // this.displayTimer = `${prefixMin}${displayMinutes} : ${prefixSec}${displaySeconds}`;
   this.displayTimer = ` <i class="ico-TimeCircle ml-1 text-xl"></i>
      <span class="p-1 text-sm bg-black-100 rounded w-[30px] text-center">${prefixSec}${displaySeconds}</span>
      <span class="mx-1">:</span>
      <span class="p-1 text-sm bg-black-100 rounded w-[30px] text-center">${prefixMin}${displayMinutes}</span>`;

   if (seconds == 0) {
    clearInterval(timer);
   }
  }, 1000);
 }

 proceedReserve() {
  const pageRoute = this.router.routerState.snapshot.url.split('/').length;

  this.webengageService.trackIntrack('show-last-reserve-modal', {
   pageName: pageRoute == 2 ? 'PHP' : pageRoute == 3 ? 'PLP' : 'PDP',
   status: this.latestActiveReserve?.reserveStatusId == 112 ? 'waiting for hotel response' : 'payment',
   Platform: /Android|iPhone/.test(window.navigator.userAgent) ? 'mobile' : 'desktop',
   reserveId: this.latestActiveReserve.reserveId,
  });
 }
}
